import { primaryColors } from "theme/themes";

import { SvgConsentIntro } from "components/Images/consent";
import steps from "./steps";

const consent = {
  id:'consent',
  title: "Consent",
  path: "/consent",
  description: "Meet Alex and Sam as they navigate consent after meeting at a party",
  backgroundColor: primaryColors.purple,
  theme: "purple",
  intro: {
    backgroundImage: SvgConsentIntro,
    text: "This is the story of Sam & Alex as they navigate consent. Alex has just arrived at a friend’s house party. Alex notices Sam across the room, walks over and asks them to dance.",
  },
  finalStepLearnmore: {
    title: "Where to find help 👋",
    content: "<p>When it comes to sexual activity in a relationship, consent is really important. It’s important to remember that everyone involved has a responsibility to make sure they feel safe and comfortable every step along the way. Remember, your actions towards the person you’re with can greatly affect the way they feel about you, themselves, <a target='_blank' href='https://bodytalk.org.au/relationships/'>the relationship, and sex in general</a>.<p>If you are in immediate danger and require assistance, please call '000'. If you require general support or you know anyone who might have any questions, or they just need to talk, then check out the links below. They are all confidential - that means they don't have to tell anyone who they are, and they won't tell anyone that they have contacted them.<p><a target='_blank' href='https://bodytalk.org.au/contact-us/'>Family Planning NSW Talkline 1300 658 886</a><br><a target='_blank' href='https://kidshelpline.com.au/teens'>Kids Help Line - 1800 551 800</a><br><a target='_blank' href='https://www.lifeline.org.au/'>Lifeline - 13 1114</a><br><a target='_blank' href='https://mensline.org.au/'>Mensline Australia - Men and Boys support</a><br><a target='_blank' href='https://fullstop.org.au/'>Full Stop Australia - Sexual assault support</a><br><a target='_blank' href='https://relationships.org.au/'>Relationships Australia</a>"
  },
  finalStepThankYou: {
    title:"Thanks for participating!",
    content: "<p>It is good to remember that our experiences are what shape us, and our actions can have either positive or negative impacts on our life and the lives of others.</p>"
  }
  ,
  firstStepId: 'consent-1',
  steps: steps
};

export default consent;
